import { SystemConstants } from "src/common/constants";

const GET_SERVICE_DEBITS = 'GET_SERVICE_DEBITS';
export const GET_SERVICE_DEBITS_API = GET_SERVICE_DEBITS + SystemConstants.API_LOADER.TRIGGER_SUFFIX;
export const GET_SERVICE_DEBITS_SUCCESS = GET_SERVICE_DEBITS + SystemConstants.API_LOADER.SUCCESS_SUFFIX;
export const GET_SERVICE_DEBITS_ERROR = GET_SERVICE_DEBITS + SystemConstants.API_LOADER.ERROR_SUFFIX;